var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3395_24716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#FFE1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 0C11.7567 0 11.5152 0.00811267 11.2754 0.0224064C17.5653 0.397183 22.2428 5.61595 22.2428 12C22.2428 18.384 17.5653 23.6028 11.2754 23.9776C11.5152 23.9919 11.7567 24 12.0001 24C18.6275 24 24.0001 18.6274 24.0001 12C24.0001 5.37257 18.6275 0 12.0001 0Z",
    fill: "#FFE1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 22.2432C17.6574 22.2432 22.2432 17.6574 22.2432 12.0005C22.2432 6.34362 17.6574 1.75781 12.0005 1.75781C6.34362 1.75781 1.75781 6.34362 1.75781 12.0005C1.75781 17.6574 6.34362 22.2432 12.0005 22.2432Z",
    fill: "#E81530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.75781C11.7564 1.75781 11.5148 1.76694 11.2754 1.78365C16.5941 2.15548 20.7934 6.58732 20.7934 12.0005C20.7934 17.4137 16.5941 21.8455 11.2754 22.2174C11.5148 22.2341 11.7564 22.2432 12 22.2432C17.6569 22.2432 22.2427 17.6574 22.2427 12.0005C22.2427 6.34365 17.6569 1.75781 12 1.75781Z",
    fill: "#E81530"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3395_24716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 14.9993L13.9979 12L17 9.00071L14.9993 7L12 10.0007L8.99929 7L7 9.00071L9.99929 12L7 14.9993L8.99929 17L12 13.9993L14.9993 17L17 14.9993Z",
    fill: "#FFE1E1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3395_24716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3395_24716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFail);
export default __webpack_public_path__ + "static/media/icon_fail.0ef84085428af5bf0f0a9e6b9c69e51f.svg";
export { ForwardRef as ReactComponent };